import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

export default class extends Controller {
  static targets = ["input", "results", "selectedId"];
  static values = {
    countryId: String,
  };

  connect() {
    StimulusReflex.register(this);

    // Listen for country selection events
    document.addEventListener(
      "countrySelected",
      this.handleCountrySelected.bind(this),
    );
  }

  disconnect() {
    document.removeEventListener(
      "countrySelected",
      this.handleCountrySelected.bind(this),
    );
  }

  handleCountrySelected(event) {
    const { countryId } = event.detail;
    this.countryIdValue = countryId;

    // Clear subdivision selection when country changes
    this.selectedIdTarget.value = "";
    this.inputTarget.value = "";
  }

  search() {
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Get country ID from value or find it from the form
    const countryId = this.countryIdValue || this.getCountryId();
    if (!countryId) {
      console.log("No country ID available for subdivision search");
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Set the query and country_id in the dataset for the reflex to access
    this.element.dataset.query = query;
    this.element.dataset.countryId = countryId;

    // Give the results div a unique ID
    const uniqueId = `subdivision-results-${Date.now()}`;
    this.resultsTarget.id = uniqueId;
    this.element.dataset.resultsId = uniqueId;

    // Trigger the reflex
    this.stimulate("SubdivisionSearch#search");
  }

  getCountryId() {
    // Try to find the country ID from the country search field in the same form
    const countryField = this.element
      .closest("form")
      ?.querySelector('[data-country-search-target="selectedId"]');
    return countryField ? countryField.value : null;
  }

  // Reflex lifecycle methods
  beforeSearch() {
    this.resultsTarget.classList.add("opacity-50");
  }

  searchSuccess() {
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.remove("hidden");
  }

  searchError(error) {
    console.error("Subdivision search error:", error);
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.add("hidden");
  }

  select(event) {
    const subdivisionId = event.currentTarget.dataset.subdivisionId;
    const subdivisionName = event.currentTarget.dataset.subdivisionName;

    this.selectedIdTarget.value = subdivisionId;
    this.inputTarget.value = subdivisionName;
    this.resultsTarget.classList.add("hidden");

    // Trigger change event for form validation
    this.inputTarget.dispatchEvent(new Event("change"));
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden");
  }
}
